// PDF Scanner Page
// Page component for JEE Mains PDF scanning functionality

import React from 'react';
import JEEMainsPDFScannerComponent from '../components/JEEMainsPDFScanner.js';
import SEOHead from '../components/SEOHead.js';

const PDFScanner = () => {
  return (
    <>
      <SEOHead 
        title="JEE Mains PDF Scanner - Extract Questions from PDF"
        description="Upload JEE Mains PDF files to automatically extract questions, answers, and metadata. Supports Physics, Chemistry, and Mathematics questions."
        keywords="JEE Mains, PDF scanner, question extraction, exam preparation, physics, chemistry, mathematics"
      />
      
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-8">
          <JEEMainsPDFScannerComponent />
        </div>
      </div>
    </>
  );
};

export default PDFScanner;
